/* eslint-disable no-param-reassign */
// eslint-disable-next-line import/prefer-default-export
export const transformCompanyInfoToUpperCase = payload => {
    payload.address.address = payload.address.address?.toUpperCase();
    payload.companyName = payload.companyName.toUpperCase();
  
    return payload;
};